import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  AxisZArrow,
  // PuzzleOutline,
} from 'mdi-material-ui';

import {
  GridItem,
  GridContainer,
  CustomTabs,
} from '../../generic';

import {
  ApplicationFTPExportIntegrationEditCard,
  ApplicationDeltaCloudExportIntegrationEditCard,
} from '../components';

const ApplicationExportIntegrationsTab = (props) => {
  const { application, canEdit } = props;
  const { t } = useTranslation('translations');

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          headerColor="rose"
          tabs={[
            {
              tabName: t('exportIntegrations.ftp.title'),
              tabIcon: AxisZArrow,
              tabContent: (
                <ApplicationFTPExportIntegrationEditCard
                  canEdit={canEdit}
                  application={application}
                />
              ),
            },
            {
              tabName: t('exportIntegrations.deltaCloud.title'),
              tabIcon: AxisZArrow,
              tabContent: (
                <ApplicationDeltaCloudExportIntegrationEditCard
                  canEdit={canEdit}
                  application={application}
                />
              ),
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  );
};

const propTypes = {
  // eslint-disable-next-line react/require-default-props, react/forbid-prop-types
  application: PropTypes.object,
  // application: PropTypes.shape({
  //   id: PropTypes.string,
  //   appID: PropTypes.string,
  // }).isRequired,
  canEdit: PropTypes.bool.isRequired,
};

ApplicationExportIntegrationsTab.propTypes = propTypes;

export default ApplicationExportIntegrationsTab;
